<div>
  <mat-checkbox [(ngModel)]="withArrows" (ngModelChange)="withArrowsChanged()">
    Pijltjes{{ multiple ? ' IP-bord #' + (index + 1) : '' }}
  </mat-checkbox>

  <ng-container *ngIf="withArrows">
    <mat-card class="top-card mat-elevation-z0 secondary-border-color">
      <div class="d-flex">
        <div class="amount-label">Aantal pijltjes wijzend naar rechts</div>
        <div class="amount-input">
          <mat-form-field appearance="outline">
            <input
              [required]="withArrows"
              matInput
              type="number"
              mask="0*"
              [(ngModel)]="ipBoardPlacement.arrows.amountArrowsRight"
              (ngModelChange)="amountArrowsChanged()"
            />
          </mat-form-field>
        </div>
      </div>
      <div class="d-flex">
        <div class="amount-label">Aantal pijltjes wijzend naar links</div>
        <div class="amount-input">
          <mat-form-field appearance="outline">
            <input
              [required]="withArrows"
              matInput
              type="number"
              mask="0*"
              [(ngModel)]="ipBoardPlacement.arrows.amountArrowsLeft"
              (ngModelChange)="amountArrowsChanged()"
            />
          </mat-form-field>
        </div>
      </div>

      <div class="upper-space">
        <textarea-input
          [title]="'Info omtrent het ontwerp van de pijlen'"
          [initContent]="ipBoardPlacement.arrows.arrowsDesign"
          [placeholder]="''"
          [client]="client"
          [sensitive]="true"
          (answer)="arrowsDesignChanged($event)"
        ></textarea-input>
      </div>

      <div class="upper-space">
        <textarea-input
          [title]="'Info omtrent de locatie van de pijlen'"
          [initContent]="ipBoardPlacement.arrows.arrowsLocation"
          [placeholder]="''"
          [client]="client"
          [sensitive]="true"
          (answer)="arrowsLocationChanged($event)"
        ></textarea-input>
      </div>

      <div class="upper-space">
        <file-picker
          [inputProduct]="ipBoard"
          [formSection]="'arrowsDesign'"
          [client]="client"
          [uploadButtonLabel]="'Foto opladen'"
          (answer)="onArrowsDesignUpload()"
        ></file-picker>
      </div>
    </mat-card>
  </ng-container>
</div>
